// extracted by mini-css-extract-plugin
export default {"logout":"icons_logout__+PR4g","home":"icons_home__ISEjQ","profile":"icons_profile__SA8vC","settings":"icons_settings__hIfjI"};